const USER = 'user';
const GIG = 'gig';
const STUDIO = 'studio';
const PAGE_SIZE = 5;
const PATHFINDER_RATINGS_INDEX = 'ratings_index';

module.exports = {
    USER,
    GIG,
    STUDIO,
    PAGE_SIZE,
    PATHFINDER_RATINGS_INDEX,
};
